export default {
	state: {
		dataToPass: {}
	},
    mutations: {
		SET_VALUE_TO_PASS(state, data) {
			state.dataToPass = data;
		},
	},

	actions: {
		setValueToPass({ commit }, data) {
			commit('SET_VALUE_TO_PASS', data);
		}
	}
}